<template>
  <div>
    <!-- Search form -->
    <b-form ref="searchForm" @submit.stop.prevent="submitSearchText()">
      <b-form-group class="m-0 form-group-search"> 
        <b-input-group class="input-group-seamless" :size="searchBarSize">
          <template v-if="!hideIconSearch">
            <b-input-group-text slot="prepend">
              <font-awesome-icon class="mx-auto" icon="search" />
            </b-input-group-text>
          </template>
          <b-form-input id="search-bar" v-model="searchText" required :placeholder="placeholder" />
          <template slot="append">
            <b-input-group-text v-if="!isSearchTextEmpty" slot="append" class="button-clear-search">
              <a href="javascript:void(0);">
                <font-awesome-icon
                  class="mx-auto"
                  icon="times"
                  :style="{ color: 'rgba(7, 9, 25, 0.5)' }"
                  @click.prevent.stop="resetSearchText()"
                />
              </a>
            </b-input-group-text>
            <slot name="button-search-inner"></slot>
          </template>
        </b-input-group>
        <slot name="button-search-outer" :submit-search="submitSearchText" :reset-search="resetSearchText"></slot>

      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { debounce } from 'lodash';

library.add(faSearch, faTimes);

export default {
  components: {
    'font-awesome-icon': FontAwesomeIcon
  },

  model: {
    prop: 'searchKeyWords',
    event: 'search'
  },

  props: {
    /**
     * Array of keyword for searching
     *
     * @type {String[]}
     * @model
     */
    searchKeyWords: {
      type: Array,
      default: () => []
    },

    /**
     * Placeholder for show search bar
     *
     * @type {String}
     */
    placeholder: {
      type: String,
      default: 'Search here...'
    },

    enableLowerCase: {
      type: Boolean,
      default: true
    },

    hideIconSearch: {
      type: Boolean,
      default: false
    },
    hideSearchButton: {
      type: Boolean,
      default: true
    },

    onChangeMode: {
      type: Boolean,
      default: false
    },
    /**
     * Size of search bar
     *
     * @type {String}
     */
    searchBarSize: {
      type: String,
      default: 'md'
    }
  },

  data() {
    return {
      /**
       * String of keywords that user want to search
       *
       * @type {String}
       */
      searchText: this.searchKeyWords.join(' ')
    };
  },

  computed: {
    /**
     * check search input that is empty or not
     *
     * @return {Boolean}
     */
    isSearchTextEmpty() {
      return this.searchText.length === 0 ? true : false;
    }
  },

  watch: {
    searchKeyWords: {
      handler(searchKeyWords) {
        if (!searchKeyWords.length) {
          this.searchText = '';
        } else {
          // Update the search text when searchKeyWords changes externally
          this.searchText = searchKeyWords.join(' ');
        }
      },
      deep: true
    },

    searchText: {
      handler() {
        if (this.onChangeMode) {
          this.submitSearchText();
        }
      }
    }
  },

  methods: {
    /**
     * Split search text from user and trigger searching from server
     */
    submitSearchText() {
      // Check if form is valid (this will trigger HTML5 validation messages)
      if (!this.$refs.searchForm.checkValidity()) {
        // If form is invalid, trigger native validation display
        this.$refs.searchForm.reportValidity();
        return;
      }

      if (this.isSearchTextEmpty) return this.resetSearchText();

      let searchKeyWords = this.searchText;

      if (this.enableLowerCase) {
        searchKeyWords = searchKeyWords.toLowerCase();
      }

      // searchKeyWords = searchKeyWords.trim().replace(/\s+/g, ' ').split(' ');
      searchKeyWords = searchKeyWords.trim().split(/[\s,]+/);

      /**
       * Remove white space if contain more than 1
       */
      this.searchText = this.searchText.replace(/\s+/g, ' ');

      /**
       * Trigger searching event
       *
       * @event search
       * @property {String[]} searchKeyWords keywords that user want to search
       */

      this.$emit('search', searchKeyWords);
    },

    /**
     * Reset search bar and trigger to clear result from searching
     */
    resetSearchText() {
      this.searchText = '';
    },

    mounted() {
      this.submitSearchText = debounce(this.submitSearchText, 1000);
    }
  }
};
</script>

<style scoped>
::v-deep .input-group-append {
  width: max-content;
}
::v-deep fieldset > div {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap:16px;

}
/* .form-group-search > div{
  background-color: tomato;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
} */

.button-clear-search {
  width: 40px;
  text-align: center;
  justify-content: center;
}
</style>
